import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import Logo from '#/assets/images/logo.png';
import { FieldError } from '#/common/components';
import { PasswordField } from '#/common/components/PasswordField';
import { Button } from '#/components/ui';
import { RESET_TOKEN, UIDB } from '#/utils';
import { useResetPassword } from '..';

const ResetPassword = () => {
    const { uid, token } = useParams();

    const {
        navigateToLogin,
        handleChangeReset,
        handleSubmitReset,
        resetErrors,
        resetTouched,
        resetValues,
        setResetValues,
        resetPasswordApiLoading,
    } = useResetPassword();

    useEffect(() => {
        if (uid && token) {
            setResetValues(UIDB, uid);
            setResetValues(RESET_TOKEN, token);
        }
    }, [uid, token]);

    return (
        <div className='min-h-screen bg-grid-lines bg-cover bg-center bg-no-repeat flex items-center justify-center px-4'>
            <div className='w-full min-h-[calc(100dvh-67px)] border-lightGray sm:min-h-0 flex flex-col gap-12 justify-center items-center max-w-md bg-white rounded-2xl shadow-md px-12 py-16'>
                <img src={Logo} alt='logo' className='w-20 h-20' />
                <div className='flex flex-col gap-6'>
                    <div className='text-center space-y-3'>
                        <h3 className='text-secondary font-cormorant text-[2rem] font-bold'>Reset Password</h3>
                        <p className='text-sm font-normal leading-4 text-gray500'>
                            Please add your password and confirm password
                        </p>
                    </div>

                    <form onSubmit={handleSubmitReset} className='space-y-4 w-full'>
                        <div className='space-y-2 min-w-[18.5rem] sm:w-[22rem] xl:w-[24.3125rem]'>
                            <label htmlFor='password' className='block text-sm font-medium text-gray700'>
                                Password
                            </label>
                            <PasswordField
                                id='password'
                                name='password'
                                className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                value={resetValues?.password}
                                onChange={handleChangeReset}
                            />

                            <FieldError error={resetTouched?.password && resetErrors?.password} />
                        </div>
                        <div className='space-y-2'>
                            <label htmlFor='confirmPassword' className='block text-sm font-medium text-gray700'>
                                Confirm Password
                            </label>
                            <PasswordField
                                id='confirmPassword'
                                name='confirmPassword'
                                className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                value={resetValues?.confirmPassword}
                                onChange={handleChangeReset}
                            />

                            <FieldError error={resetTouched?.confirmPassword && resetErrors?.confirmPassword} />
                        </div>

                        <Button
                            type='submit'
                            disabled={resetPasswordApiLoading}
                            className='w-full h-[2.625rem] flex justify-center py-3 px-5 border border-transparent text-sm font-medium rounded-lg cursor-pointer'
                        >
                            Reset Password
                        </Button>
                    </form>

                    <div className='text-center'>
                        <Button
                            type='button'
                            variant='link'
                            onClick={navigateToLogin}
                            className='text-sm text-gray500 hover:underline cursor-pointer'
                        >
                            Back to Login
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { ResetPassword };
